t = require('views/internal/teacup-with-helpers')('search_results_card')

module.exports = ->
  t.div '.search-result-card-container.js-list-card-container', ->
    t.div '.search-result-card-container-fade'

  t.div '.search-result-card-details', ->

    t.p '.u-bottom', ->
      t.a '.search-result-card-details-name', { href: t.mustacheVar('url') }, ->
        t.text t.mustacheVar('name')

    t.p '.u-bottom.quiet', ->
      t.format 'in-listname-archived-on-boardname', { listName: t.mustacheVar('listName'), archived: t.mustacheVar('archived'), boardName: t.mustacheVar('boardName'), permLevel: t.mustacheVar('permLevel') }

  t.a '.search-result-card-hover-target', { href: t.mustacheVar('url') }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/search_results_card.coffee